import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useCreateAdUnit = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const createAdUnitHook = async (ad_unit, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-ad-unit-service/v1/create/`,
        {ad_unit}
      );

      const json = response?.data;
      if (json?.payload) {
        setSuccess(true);
        handleUpdate(json?.payload);
      } else {
        setError("Failed to create ad unit");
      }
    } catch (error) {
      setError("An error occurred while creating the ad unit");
    } finally {
      setLoading(false);
    }
  };

  return [ createAdUnitHook, loading, error, success ];
};